import React, { useState, useEffect } from 'react';
import {
  Menu,
  X,
  Globe
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Nav  = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [language, setLanguage] = useState('fr');
  const [scrolled, setScrolled] = useState(false);

  const content = {
    fr: {
      nav: [
        { label: 'Accueil', path: '/' },
        { label: 'Chambres', path: '/riad-lina' },
        { label: 'Restaurant', path: '/restaurant' },
        // { label: 'Excursions', path: '/excursions' },
        { label: 'Notre Hôtel', path: '/galerie' },
        { label: 'Contact', path: '/contact' }
      ],
    },
    en: {
      nav: [
        { label: 'Home', path: '/' },
        { label: 'Rooms', path: '/riad-lina' },
        { label: 'Restaurant', path: '/restaurant' },
        // { label: 'Excursions', path: '/excursions' },
        { label: 'Gallery', path: '/gallery' },
        { label: 'Contact', path: '/contact' }
      ],
    }
  };

  const t = content[language];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <div style={{ fontFamily: 'Georgia, serif', overflow: 'hidden' }}>
      {/* Navigation */}
      <nav style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 1000,
        background: scrolled ? 'rgba(20, 20, 20, 0.95)' : 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)',
        transition: 'all 0.3s',
        borderBottom: scrolled ? '1px solid rgba(212, 175, 55, 0.3)' : 'none'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '20px 30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1
            style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '32px',
              color: '#d4af37',
              fontWeight: 700,
              letterSpacing: '2px',
              cursor: 'pointer'
            }}
            onClick={() => handleNavigation('/')}
          >
            RIAD LINA
          </h1>

          <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
            {/* Desktop Menu */}
            <div style={{ display: window.innerWidth > 768 ? 'flex' : 'none', gap: '35px' }}>
              {t.nav.map((item, i) => (
                <span
                  key={i}
                  onClick={() => handleNavigation(item.path)}
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontSize: '15px',
                    letterSpacing: '1px',
                    transition: 'color 0.3s',
                    fontWeight: 500,
                    cursor: 'pointer'
                  }} 
                  onMouseEnter={(e) => (e.target.style.color = '#d4af37')}
                  onMouseLeave={(e) => (e.target.style.color = '#fff')}
                >
                  {item.label}
                </span>
              ))}
            </div>

            {/* Language Toggle */}
            <button
              onClick={() => navigate('/contact')}
              style={{
                background: 'transparent',
                border: '2px solid #d4af37',
                color: '#d4af37',
                padding: '8px 16px',
                borderRadius: '25px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                transition: 'all 0.3s',
                fontWeight: 600
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#d4af37';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#d4af37';
              }}
            >
              Réserver
            </button>
            {/* <button
              onClick={() => setLanguage(language === 'fr' ? 'en' : 'fr')}
              style={{
                background: 'transparent',
                border: '2px solid #d4af37',
                color: '#d4af37',
                padding: '8px 16px',
                borderRadius: '25px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                transition: 'all 0.3s',
                fontWeight: 600
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#d4af37';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#d4af37';
              }}
            >
              <Globe size={16} /> {language.toUpperCase()}
            </button> */}

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{
                display: window.innerWidth <= 768 ? 'block' : 'none',
                background: 'none',
                border: 'none',
                color: '#d4af37',
                cursor: 'pointer'
              }}
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div
            style={{
              background: 'rgba(20, 20, 20, 0.98)',
              padding: '30px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px'
            }}
          >
            {t.nav.map((item, i) => (
              <span
                key={i}
                onClick={() => handleNavigation(item.path)}
                style={{
                  color: '#fff',
                  fontSize: '18px',
                  letterSpacing: '1px',
                  cursor: 'pointer'
                }}
              >
                {item.label}
              </span>
            ))}
          </div>
        )}
      </nav>
    </div>
  );
};
export default Nav;
